import { Fragment } from 'react'

const SideNav = <T extends unknown>({
  className,
  navItems,
  stage,
  disabled,
  setStage,
}: {
  className?: string
  navItems: {
    label: string
    targetStage: T
  }[]
  stage?: T
  disabled?: boolean
  setStage: (data: Partial<T>) => void
}) => {
  const selectedIndex = navItems.findIndex(
    (items) => items.targetStage === stage
  )
  return (
    <div
      className={`flex items-end md:items-start flex-row md:flex-col cursor-pointer max-w-[100vw] ${className}`}
    >
      {navItems.map((item) => {
        const { label, targetStage } = item
        const isActive = targetStage === stage

        return (
          <Fragment key={`sidenav-item-${item.label}`}>
            <div
              className={`flex flex-col items-center mx-1 md:mx-0`}
              onClick={() => {
                if (!disabled) setStage(targetStage)
              }}
            >
              <span
                className={`text-sm mt-4 text-right ${isActive ? 'font-bold underline' : ''}`}
              >
                {label}
              </span>
            </div>
          </Fragment>
        )
      })}
    </div>
  )
}

export default SideNav
